import { Box } from "@material-ui/core";
import React from "react";
import MessagingBoxBody from "./MessagingBoxBody.jsx";
import MessagingBoxFooter from "./MessagingBoxFooter.jsx";
import MessagingBoxHeader from "./MessagingBoxHeader.jsx";

/** */
const MessagingBox = () => {
  return (
    <Box flex="1" display="flex" flexDirection="column">
      <MessagingBoxHeader />
      <MessagingBoxBody />
      <MessagingBoxFooter />
    </Box>
  );
};

export default MessagingBox;
